<template>
  <v-dialog v-model="dialogView" max-width="90%" persistent scrollable>
    <v-card max-height="85vh">
      <v-card-title class="py-2">
        <v-btn
          v-if="navigationStack.length > 1"
          icon
          small
          @click="goBack"
          class="mr-2"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span>Detalles de la Factura</span>
        <v-spacer></v-spacer>
        <v-chip small color="info" v-if="navigationStack.length > 1">
          Nivel {{ navigationStack.length }}
        </v-chip>
      </v-card-title>

      <v-card-text v-if="loading" class="text-center py-8">
        <v-progress-circular
          indeterminate
          size="128"
          width="4"
          class="mb-3"
          color="primary"
        />
        <div class="text-subtitle-2">
          Cargando detalles del CFDI ...
        </div>
      </v-card-text>

      <v-card-text v-else class="px-4 py-3">
        <v-row dense>
          <!-- INFORMACIÓN GENERAL -->
          <v-col cols="12" class="pb-1 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-file-document</v-icon>
              Información General
            </div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">UUID:</div>
            <div class="text-body-2">{{ viewedItem.id_uuid_factura }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="2">
            <div class="text-caption font-weight-medium">Estado SAT:</div>
            <div class="text-body-2">{{ viewedItem.estado_sat || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="1">
            <div class="text-caption font-weight-medium">Versión:</div>
            <div class="text-body-2">{{ viewedItem.version || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="2">
            <div class="text-caption font-weight-medium">Tipo:</div>
            <div class="text-body-2">{{ viewedItem.tipo || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="2">
            <div class="text-caption font-weight-medium">Serie:</div>
            <div class="text-body-2">{{ viewedItem.serie || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="2">
            <div class="text-caption font-weight-medium">Folio:</div>
            <div class="text-body-2">{{ viewedItem.folio || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="4">
            <div class="text-caption font-weight-medium">Fecha de Emisión:</div>
            <div class="text-body-2">{{ viewedItem.fecha_emision || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="4">
            <div class="text-caption font-weight-medium">Fecha de Timbrado:</div>
            <div class="text-body-2">{{ viewedItem.fecha_timbrado || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="4">
            <div class="text-caption font-weight-medium">Fecha de Cancelación:</div>
            <div class="text-body-2">{{ viewedItem.fecha_cancelacion || 'N/D' }}</div>
          </v-col>

         <v-col cols="12">
          <v-viewer
            v-if="pdf_name"
            v-model="pdf_name"
            urlBase="/api/Pagos/ObtenerFacturaPDF"
            :label="`Factura`"
          ></v-viewer>
         </v-col>
          

          <!-- DATOS DEL EMISOR -->
          <v-col cols="12" class="pb-1 pt-2 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-domain</v-icon>
              Datos del Emisor
            </div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">RFC Emisor:</div>
            <div class="text-body-2">{{ viewedItem.rfc_emisor || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">Nombre Emisor:</div>
            <div class="text-body-2">{{ viewedItem.nombre_emisor || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">RFC PAC:</div>
            <div class="text-body-2">{{ viewedItem.rfc_pac || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">Lugar de Expedición:</div>
            <div class="text-body-2">{{ viewedItem.lugar_de_expedicion || 'N/D' }}</div>
          </v-col>

          <v-col cols="12">
            <div class="text-caption font-weight-medium">Régimen Fiscal Emisor:</div>
            <div class="text-body-2">{{ viewedItem.regimen_fiscal_emisor || 'N/D' }}</div>
          </v-col>

          <!-- DATOS DEL RECEPTOR -->
          <v-col cols="12" class="pb-1 pt-2 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-account</v-icon>
              Datos del Receptor
            </div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">RFC Receptor:</div>
            <div class="text-body-2">{{ viewedItem.rfc_receptor || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">Nombre Receptor:</div>
            <div class="text-body-2">{{ viewedItem.nombre_receptor || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">Uso CFDI:</div>
            <div class="text-body-2">{{ viewedItem.uso_cfdi || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="4" md="3">
            <div class="text-caption font-weight-medium">Domicilio Fiscal:</div>
            <div class="text-body-2">{{ viewedItem.domicilio_fiscal_receptor || 'N/D' }}</div>
          </v-col>

          <v-col cols="12">
            <div class="text-caption font-weight-medium">Régimen Fiscal Receptor:</div>
            <div class="text-body-2">{{ viewedItem.regimen_fiscal_receptor || 'N/D' }}</div>
          </v-col>

          <!-- INFORMACIÓN FINANCIERA -->
          <v-col cols="12" class="pb-1 pt-2 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-currency-usd</v-icon>
              Información Financiera
            </div>
          </v-col>

          <v-col cols="6" sm="3">
            <div class="text-caption font-weight-medium">Moneda:</div>
            <div class="text-body-2">{{ viewedItem.moneda || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="3">
            <div class="text-caption font-weight-medium">Tipo de Cambio:</div>
            <div class="text-body-2">{{ viewedItem.tipo_de_cambio || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="3">
            <div class="text-caption font-weight-medium">Forma de Pago:</div>
            <div class="text-body-2">{{ viewedItem.forma_de_pago || 'N/D' }}</div>
          </v-col>

          <v-col cols="6" sm="3">
            <div class="text-caption font-weight-medium">Método de Pago:</div>
            <div class="text-body-2">{{ viewedItem.metodo_de_pago || 'N/D' }}</div>
          </v-col>

          <v-col cols="4" sm="3">
            <div class="text-caption font-weight-medium">Subtotal:</div>
            <div class="text-body-2">${{ formatMoney(viewedItem.sub_total) }}</div>
          </v-col>

          <v-col cols="4" sm="3">
            <div class="text-caption font-weight-medium">Descuento:</div>
            <div class="text-body-2">${{ formatMoney(viewedItem.descuento) }}</div>
          </v-col>

          <v-col cols="4" sm="3">
            <div class="text-caption font-weight-medium">Combustible:</div>
            <div class="text-body-2">{{ viewedItem.combustible || 'N/D' }}</div>
          </v-col>

          <v-col cols="12" sm="3">
            <div class="text-caption font-weight-medium">Total:</div>
            <div class="text-h6 font-weight-bold primary--text">
              ${{ formatMoney(viewedItem.total) }}
            </div>
          </v-col>

          <!-- IMPUESTOS -->
          <v-col cols="12" class="pb-1 pt-2 text-center">
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-receipt</v-icon>
              Impuestos
            </div>
          </v-col>

          <v-col cols="12">
            <v-simple-table v-if="viewedItem.impuestos && viewedItem.impuestos.length > 0" dense>
              <thead>
                <tr>
                  <th class="text-left text-caption">Tipo</th>
                  <th class="text-left text-caption">Impuesto</th>
                  <th class="text-left text-caption">Factor</th>
                  <th class="text-right text-caption">Tasa/Cuota</th>
                  <th class="text-right text-caption">Base</th>
                  <th class="text-right text-caption">Importe</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(imp, i) in viewedItem.impuestos" :key="'impuesto-' + i">
                  <td class="text-body-2">{{ imp.tipo_impuesto }}</td>
                  <td class="text-body-2">{{ imp.impuesto }}</td>
                  <td class="text-body-2">{{ imp.tipo_factor }}</td>
                  <td class="text-right text-body-2">{{ (imp.tasa_o_cuota * 100).toFixed(2) }}%</td>
                  <td class="text-right text-body-2">${{ formatMoney(imp.base) }}</td>
                  <td class="text-right text-body-2">${{ formatMoney(imp.importe) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <div v-else class="text-center text--disabled text-body-2 py-2">
              No hay impuestos registrados
            </div>
          </v-col>

          <!-- RELACIONES -->
          <v-col 
            v-if="viewedItem.relaciones && viewedItem.relaciones.length > 0"
            cols="12" 
            class="pb-1 pt-2 text-center"
          >
            <div class="text-subtitle-1 font-weight-bold">
              <v-icon small>mdi-link-variant</v-icon>
              CFDIs Relacionados
            </div>
          </v-col>

          <v-col v-if="viewedItem.relaciones && viewedItem.relaciones.length > 0" cols="12">
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left text-caption">UUID</th>
                  <th class="text-left text-caption">Tipo de Relación</th>
                  <th class="text-center text-caption">Disponible</th>
                  <th class="text-center text-caption">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rel, i) in viewedItem.relaciones" :key="'relacion-' + i">
                  <td class="text-body-2">{{ rel.id_uuid_factura }}</td>
                  <td class="text-body-2">{{ rel.tipo_relacion }}</td>
                  <td class="text-center">
                    <v-chip 
                      x-small 
                      :color="rel.disponible ? 'success' : 'error'"
                      text-color="white"
                    >
                      {{ rel.disponible ? 'Sí' : 'No' }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-btn
                      v-if="rel.disponible"
                      icon
                      x-small
                      color="primary"
                      @click="open(rel.id_uuid_factura, true)"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <span v-else class="text--disabled text-caption">N/A</span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="py-2">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeDialogView">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import VViewer from '@/components/VViewer.vue';

export default {
  components: {
    VViewer
  },
  computed: {
    ...mapState(['token']),
    pdf_name(){
      if(!this.viewedItem || !this.viewedItem.id_uuid_factura) return null;
      return `${this.viewedItem.id_uuid_factura}.pdf`
    },
  },
  data: () => ({
    dialogView: false,
    loading: false,
    viewedItem: {},
    navigationStack: [], // Pila para el historial de navegación
  }),
  methods: {
    open(id_uuid_factura, internal = false) {
      if (!internal) {
        this.dialogView = true;
        this.navigationStack = []; // Reiniciar la pila si es apertura externa
      }
      
      this.loading = true;
      
      axios
        .get(`/Pagos/FacturaDetalles/${id_uuid_factura}`)
        .then(response => {
          // Agregar a la pila antes de cambiar la vista
          this.navigationStack.push({
            id: id_uuid_factura,
            data: response.data
          });
          
          this.viewedItem = response.data;
        })
        .catch(error => {
          console.log(error);
          this.$toast.error('Error al cargar los detalles de la factura');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    goBack() {
      if (this.navigationStack.length > 1) {
        // Remover el elemento actual
        this.navigationStack.pop();
        
        // Obtener el elemento anterior
        const previous = this.navigationStack[this.navigationStack.length - 1];
        
        // Restaurar la vista anterior sin hacer otra petición
        this.viewedItem = previous.data;
      }
    },
    
    closeDialogView() {
      this.dialogView = false;
      this.viewedItem = {};
      this.navigationStack = [];
      this.loading = false;
    },
    
    formatMoney(value) {
      if (value == null) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
}
</script>